import { Bot } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { SubagentCompletionEvent } from "@/lib/render-items";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

interface SubagentCompletionEventBannerProps {
  event: SubagentCompletionEvent;
  className?: string;
}

/** Render an async sub-agent completion continuation as a system event. */
export function SubagentCompletionEventBanner({
  event,
  className,
}: SubagentCompletionEventBannerProps) {
  const { t } = useTranslation();

  return (
    <Alert
      className={cn(
        "mx-4 mb-4 w-auto border-primary/20 bg-primary/5 py-2.5 [&>svg]:top-1/2 [&>svg]:-translate-y-1/2",
        className,
      )}
      data-testid="subagent-completion-event"
      role="status"
    >
      <Bot className="mt-0.5 size-4 shrink-0 text-primary" aria-hidden="true" />
      <AlertDescription className="min-w-0 overflow-hidden break-words text-foreground">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
          <AlertTitle className="mb-0">
            {t("chat:subagentCompletion.title")}
          </AlertTitle>
          <span className="min-w-0 break-words text-sm text-muted-foreground">
            {t(`chat:subagentCompletion.status.${event.terminalStatus}`)}
          </span>
        </div>
      </AlertDescription>
    </Alert>
  );
}
